import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { AccountResponse } from '@entities/account';
import { AuthService } from '@services/auth.service';
import {
  NotAuthenticatedUserError,
  NotSelectedTenantError,
} from '@errors/error';
import { SystemAdminService } from '@services/system-admin.service';

export const loggedInUserResolver: ResolveFn<AccountResponse> = () => {
  const authService = inject(AuthService);
  const systemAdminService = inject(SystemAdminService);

  const loggedInUser = authService.loggedInUser;
  if (!loggedInUser) {
    throw new NotAuthenticatedUserError();
  }

  const roleId = loggedInUser.tenant.roleId;
  if (roleId === 'system_admin') {
    const tenantId = systemAdminService.getTenantId();
    const tenantCreatedAt = systemAdminService.getTenantCreatedAt();
    if (tenantId === null) {
      throw new NotSelectedTenantError();
    }
    loggedInUser.tenant = {
      tenantId: tenantId,
      tenantName: 'テナント切替中',
      roleId: roleId,
      createdAt: tenantCreatedAt,
    };
  }

  return loggedInUser;
};
